import { useCallback } from 'react';
import { configurationUtils } from '@codametrix/ui-common';
const { getConfigValueForServiceLine, getConfigDisplayValue, serviceLineMatches } = configurationUtils;
const findConfigurationSource = (values, serviceLineName, tenantId, effectiveValue)=>{
    if (!effectiveValue || effectiveValue === null) {
        return {
            source: null,
            type: 'none',
            inheritanceMessage: null
        };
    }
    const exactMatch = values.find((v)=>v.tenantId === tenantId && serviceLineMatches(v, serviceLineName, false) && getConfigDisplayValue(v) === effectiveValue);
    if (exactMatch) {
        return {
            source: exactMatch,
            type: 'exact',
            inheritanceMessage: null
        };
    }
    const tenantDefault = values.find((v)=>v.tenantId === tenantId && v.serviceLines?.includes('*') && getConfigDisplayValue(v) === effectiveValue);
    if (tenantDefault) {
        return {
            source: tenantDefault,
            type: 'tenant-default',
            inheritanceMessage: 'tenant default'
        };
    }
    const parentTenantMatch = values.find((v)=>v.tenantId !== tenantId && v.tenantId !== '*' && (serviceLineMatches(v, serviceLineName, false) || v.serviceLines?.includes('*')) && getConfigDisplayValue(v) === effectiveValue);
    if (parentTenantMatch) {
        return {
            source: parentTenantMatch,
            type: 'parent-tenant',
            inheritanceMessage: 'parent tenant'
        };
    }
    const globalServiceLineMatch = values.find((v)=>v.tenantId === '*' && serviceLineMatches(v, serviceLineName, false) && getConfigDisplayValue(v) === effectiveValue);
    if (globalServiceLineMatch) {
        return {
            source: globalServiceLineMatch,
            type: 'global-service-line',
            inheritanceMessage: 'system default'
        };
    }
    const globalDefault = values.find((v)=>v.tenantId === '*' && v.serviceLines?.includes('*') && getConfigDisplayValue(v) === effectiveValue);
    if (globalDefault) {
        return {
            source: globalDefault,
            type: 'global-default',
            inheritanceMessage: 'system default'
        };
    }
    const anyMatch = values.find((v)=>{
        const displayValue = getConfigDisplayValue(v);
        return displayValue === effectiveValue || Array.isArray(effectiveValue) && effectiveValue.includes(displayValue);
    });
    if (anyMatch) {
        if (anyMatch.tenantId === tenantId && serviceLineMatches(anyMatch, serviceLineName, false)) {
            return {
                source: anyMatch,
                type: 'exact',
                inheritanceMessage: null
            };
        } else if (anyMatch.tenantId === tenantId && anyMatch.serviceLines?.includes('*')) {
            return {
                source: anyMatch,
                type: 'tenant-default',
                inheritanceMessage: 'tenant default'
            };
        } else if (anyMatch.tenantId !== tenantId && anyMatch.tenantId !== '*') {
            return {
                source: anyMatch,
                type: 'parent-tenant',
                inheritanceMessage: 'parent tenant'
            };
        } else if (anyMatch.tenantId === '*' && serviceLineMatches(anyMatch, serviceLineName, false)) {
            return {
                source: anyMatch,
                type: 'global-service-line',
                inheritanceMessage: 'system default'
            };
        } else if (anyMatch.tenantId === '*' && anyMatch.serviceLines?.includes('*')) {
            return {
                source: anyMatch,
                type: 'global-default',
                inheritanceMessage: 'system default'
            };
        }
    }
    return {
        source: null,
        type: 'none',
        inheritanceMessage: null
    };
};
export const useConfigurationEffectiveValue = (configDetail, tenantId)=>{
    const getEffectiveValueForServiceLine = useCallback((serviceLineName)=>{
        console.log('configDetail', configDetail);
        if (!configDetail || !configDetail.values) {
            return {
                value: null,
                source: null,
                type: 'none',
                inheritanceMessage: null
            };
        }
        // Use the same logic as the table for consistency
        const effectiveValue = getConfigValueForServiceLine(configDetail.values, serviceLineName, tenantId);
        if (!effectiveValue) {
            return {
                value: 'Not Set',
                source: null,
                type: 'none',
                inheritanceMessage: null
            };
        }
        // Determine the source and type of this value
        const { source, type, inheritanceMessage } = findConfigurationSource(configDetail.values, serviceLineName, tenantId, effectiveValue);
        return {
            value: effectiveValue,
            source,
            type,
            inheritanceMessage
        };
    }, [
        configDetail,
        tenantId
    ]);
    return {
        getEffectiveValueForServiceLine
    };
};
